var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"mask-loading",on:{"touchmove":_vm.preventEvents}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrap"},[_c('img',{staticClass:"loading-gif",attrs:{"src":"https://resource.rcclchina.com.cn/logo/PC/logoLoadingPc.gif","alt":"loading"}})])
}]

export { render, staticRenderFns }